let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Syszu")).then(() => parcelRequire('6O5BX'));